import React from "react";
import "../styles/CasosExito.scss";

export const CasosExito = () => {
  return (
    <div className="containerCasosExito d-flex justify-content-start align-items-center flex-column">
    <div className="d-flex justify-content-center align-items-center flex-column titleCasosExito text-center">
      <span className="titleCasos mt-4">
        Cientos de alumnos nos recomiendan
      </span>
      <span className="subtitleCasos">
      Conoce los resultados reales de quienes ya confiaron en High Life Language School. Alumnos que hoy hablan inglés con seguridad y han mejorado sus oportunidades. Ellos ya lo lograron, ahora es tu turno.
      </span>
    </div>
    <div className="resenasContainerManin mt-5 mb-5">
        <div className="resena" id="resena1">
            <span className="titleResena mt-3">Perla Benitez</span>
            <div className="containerStars">
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
            </div><br/>
            <div className="containerDialogImg">
              <ion-icon name="chatbubble-ellipses-outline"></ion-icon>
            </div>
            <div className="containerOpinion mt-3">
              <span className="textOpinion">
              La escuela me encanta el teacher es muy amable y bueno;para las personas que necesitan ver resultados rápido está perfecto, las clases son muy dinámicas y se genera un ambiente súper agradable y de confianza.
              </span>
            </div>
        </div>
        <div className="resena" id="resena2">
            <span className="titleResena mt-3">Gloria S. Hernández</span>
            <div className="containerStars">
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
            </div><br/>
            <div className="containerDialogImg">
              <ion-icon name="chatbubble-ellipses-outline"></ion-icon>
            </div>
            <div className="containerOpinion mt-3">
              <span className="textOpinion">
             Estoy muy contenta con mi avance y con mis compañeros.  Las clases son amenas, agradables, interactivas, y el profesor con mucho carisma, profesionalismo y entrega.  Realmente aprendes en poco tiempo con una muy buena pronunciación y comprensión del idioma.  Muy contenta de ser alumna de esta escuela. Muchas gracias teacher por su paciencia y dedicación.
              </span>
            </div>
        </div>
        <div className="resena" id="resena3">
            <span className="titleResena mt-3">Perla Cardenas</span>
            <div className="containerStars">
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
            </div><br/>
            <div className="containerDialogImg">
              <ion-icon name="chatbubble-ellipses-outline"></ion-icon>
            </div>
            <div className="containerOpinion mt-3">
              <span className="textOpinion">
              Súper buena la escuela, llevo pocos tiempo y ya entablo conversaciones con mis compañeras, me gusto tanto que siempre pienso en inglés todo lo que quiero decir y me da por investigarlo o preguntar en mi salón de clases para tener un vocabulario más amplio, me encanta mi escuela de idiomas.
              </span>
            </div>
        </div>
    </div>
  </div>
  
  );
};

export default CasosExito;
